import { AbstractControl, ValidationErrors } from "@angular/forms";

const REGEXP = /(^\s+.*)|(.*\s+$)/;

export function noLeadingTrailingWhiteSpaceValidator(
    control: AbstractControl
): ValidationErrors | null {
    const value = control.value;
    if (value == null || value.length === 0) {
        return null;
    }
    return REGEXP.test(control.value) ? { whiteSpaces: true } : null;
}
